import { render, staticRenderFns } from "./AdminInboundDeliveryAttachedFilesDrawer.vue?vue&type=template&id=39632350&scoped=true"
import script from "./AdminInboundDeliveryAttachedFilesDrawer.vue?vue&type=script&lang=js"
export * from "./AdminInboundDeliveryAttachedFilesDrawer.vue?vue&type=script&lang=js"
import style0 from "./AdminInboundDeliveryAttachedFilesDrawer.vue?vue&type=style&index=0&id=39632350&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39632350",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39632350')) {
      api.createRecord('39632350', component.options)
    } else {
      api.reload('39632350', component.options)
    }
    module.hot.accept("./AdminInboundDeliveryAttachedFilesDrawer.vue?vue&type=template&id=39632350&scoped=true", function () {
      api.rerender('39632350', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inbound/AdminInboundDeliveryAttachedFilesDrawer.vue"
export default component.exports